import * as angular from "angular";
import template from "./entity-contact.html";
import "./entity-contact.less";
import contactInfo from "../../../../../contact-info/contact-info";

export default angular
	.module("vesl.components.entity-modal.tabs.components.entity-contact", [contactInfo])
	.component("entityContact", {
		template,
		bindings: {
			contact: "=",
			isReadonly: "<"
		}
	})
	.name;
